namespace Matrix.Indexation {
    export interface PriceTypeRow {
        PriceTypeCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
    }

    export namespace PriceTypeRow {
        export const idProperty = 'PriceTypeCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Indexation.PriceType';
        export const deletePermission = 'DataAdmin:IndexationPriceType';
        export const insertPermission = 'DataAdmin:IndexationPriceType';
        export const readPermission = 'Read:IndexationPriceType';
        export const updatePermission = 'DataAdmin:IndexationPriceType';

        export declare const enum Fields {
            PriceTypeCode = "PriceTypeCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder"
        }
    }
}
